export default function getAttributeValue(record, path) {
    if (path === undefined) {
        return null;
    }
    const segments = Array.isArray(path) ? path : [path];
    return segments.reduce((current, key) => current && current[key], record);
}
